export default "__VITE_ASSET__Hai39350__"